/** Product-facing labels for Workshop Phase 1 — never show raw enums as primary UI copy. */

export const STAGE_LABELS: Record<string, string> = {
  QUEUED: 'Queued',
  RECEIVED: 'Received',
  DIAGNOSING: 'Diagnosing',
  PLANNED: 'Planned',
  ASSIGNED: 'Assigned',
  IN_REPAIR: 'In repair',
  QC_PENDING: 'QC pending',
  READY_FOR_RELEASE: 'Ready for release',
  RELEASED: 'Released',
  CANCELLED: 'Cancelled',
  SUPERSEDED: 'Superseded',
};

export const HOLD_LABELS: Record<string, string> = {
  WAITING_PARTS: 'Waiting for parts',
  WAITING_TECHNICIAN: 'Waiting for technician',
  WAITING_APPROVAL: 'Waiting for approval',
  WAITING_VENDOR: 'Waiting for vendor',
  WAITING_DIAGNOSIS: 'Waiting for diagnosis',
  WAITING_EQUIPMENT: 'Waiting for equipment',
  WAITING_QC: 'Waiting for QC',
  WAITING_EXTERNAL_SERVICE: 'Waiting for external service',
};

export const QC_LABELS: Record<string, string> = {
  NONE: 'Not started',
  REQUIRED: 'QC required',
  PENDING: 'QC in progress',
  PASSED: 'QC passed',
  FAILED: 'QC failed',
  WAIVED: 'QC waived',
};

export const RESPONSIBILITY_LABELS: Record<string, string> = {
  NO_HIRE_CONTEXT: 'Company owned / no active hire',
  CONTRACTOR_RESPONSIBLE: 'Contractor maintenance responsibility',
  VENDOR_RESPONSIBLE: 'Vendor maintenance responsibility',
  SHARED_RESPONSIBILITY: 'Shared maintenance responsibility',
  INSUFFICIENT_HIRE_CONTEXT: 'Hire context incomplete',
  CONTRACTOR: 'Contractor',
  VENDOR: 'Vendor',
  SHARED: 'Shared',
};

export function stageLabel(code?: string | null): string {
  if (!code) return 'Not in workshop';
  return STAGE_LABELS[code] ?? code;
}

export function holdLabel(code?: string | null): string | null {
  if (!code) return null;
  return HOLD_LABELS[code] ?? code;
}

export function qcLabel(code?: string | null): string {
  if (!code) return QC_LABELS.NONE;
  return QC_LABELS[code] ?? code;
}

export function nextActionForJob(row: {
  execution_stage?: string | null;
  hold_reason?: string | null;
  qc_state?: string | null;
  cost_responsibility?: string | null;
  execution_id?: string | null;
}): string {
  if (row.cost_responsibility === 'VENDOR' && !row.execution_id) {
    return 'Vendor maintenance — exception required for internal repair';
  }
  if (!row.execution_id) return 'Open workshop intake';
  if (row.hold_reason === 'WAITING_PARTS') return 'Create or link a material request for parts';
  if (row.hold_reason) return 'Clear hold or continue when unblocked';
  switch (row.execution_stage) {
    case 'QUEUED':
      return 'Record intake';
    case 'RECEIVED':
    case 'DIAGNOSING':
      return 'Diagnose and plan work';
    case 'PLANNED':
    case 'ASSIGNED':
      return 'Start repair';
    case 'IN_REPAIR':
      return 'Complete work for QC';
    case 'QC_PENDING':
      return 'Perform QC';
    case 'READY_FOR_RELEASE':
      return 'Authorize release';
    default:
      return 'Open job';
  }
}

export const STAGE_TAG_COLOR: Record<string, string> = {
  QUEUED: 'default',
  RECEIVED: 'blue',
  DIAGNOSING: 'cyan',
  PLANNED: 'geekblue',
  ASSIGNED: 'purple',
  IN_REPAIR: 'processing',
  QC_PENDING: 'gold',
  READY_FOR_RELEASE: 'green',
  RELEASED: 'success',
};

export const HOLD_TAG_COLOR = 'orange';
